import channelParser from './parsers/channel';
import parseError from './parsers/error';

import urlTypes from './url-types';

import * as http from '../../utils/http';


// split by 50 ids per request
const MAX_IDS_IN_REQUEST = 50;


export default function (settings) {

  const parsePlaylist = _.partial(channelParser, urlTypes.PLAYLIST);


  function get(playlistIds) {

    playlistIds = _.castArray(playlistIds);

    if (!playlistIds.length) {
      return Promise.resolve({
        status: 200,
        data: [],
      });
    }

    const playlistRequests = _(playlistIds)
      .uniq()
      .chunk(MAX_IDS_IN_REQUEST)
      .map(function (chunkPlaylistIds) {
        const params = {
          id: chunkPlaylistIds.join(','),
        };
        return http.get(`${settings.apiUrl}/playlists`, { params });
      })
      .value();

    return Promise.all(playlistRequests)
      .then(function (responses) {
        const playlists = _.flatMap(responses, 'data.items');
        const parsedPlaylists = _.map(playlists, parsePlaylist);

        const missingIds = _.difference(
          playlistIds,
          _.map(parsedPlaylists, 'externalId')
        );

        const missingPlaylists = _.map(missingIds, id => parsePlaylist({ id, isExternalRemoved: true }));

        return {
          status: responses[0].status,
          data: [
            ...parsedPlaylists,
            ...missingPlaylists,
          ],
        };
      })
      .catch(parseError);
  }


  return {
    get,
  };
}



// WEBPACK FOOTER //
// ./src/transport/adapters/youtube/playlists.js